export default "__VITE_ASSET__CPvnchja__"